import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useCheckoutPayment from 'hooks/useCheckoutPayment'
import { ORDERS, CHECKOUT_CONFIRMATION } from 'constants/app-paths'
import { currencyFormat } from 'utils/format'
import { CHECKOUT_PAYMENT_METHODS } from 'constants/checkout-steps'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { InfoPage } from 'templates/InfoPage'
import { Card } from 'ui-components/Card'
import { Button } from 'ui-components/Button'
import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'

import { SideMenu } from 'components/Checkout/SideMenu'
import { Vouchers } from './components/Vouchers'
import { PaymentPlan } from './components/PaymentPlan'
import { Top, Options, Bottom } from './styles'

export default function Payment() {
  const history = useHistory()
  const [
    {
      customerName,
      paymentMethods,
      paymentMethodOptions,
      paymentPlans,
      vouchers,
      paymentVouchers,
      totalPaid,
    },
    {
      getPaymentMethods,
      addPaymentPlan,
      updatePaymenMethod,
      updatePlanMethod,
      updatePlanValue,
      canAddPaymentPlan,
      removePaymentPlan,
      addVoucher,
      removeVoucher,
      hasCustomer,
    },
  ] = useCheckoutPayment()

  useEffect(() => {
    if (!hasCustomer()) history.push(ORDERS)
  }, [hasCustomer, history])

  useEffect(() => {
    if (hasCustomer()) getPaymentMethods()
  }, [getPaymentMethods, hasCustomer])

  const onSelectMethod = ({ selectedOption, plan }) => {
    updatePaymenMethod({ selectedOption, plan })
  }

  const onSelectPlan = ({ selectedOption, plan }) => {
    updatePlanMethod({ selectedOption, plan })
  }

  const onChangeValue = ({ plan, value }) => {
    updatePlanValue({ plan, value })
  }

  const onClickNext = () => {
    history.push(CHECKOUT_CONFIRMATION)
  }

  const renderPaymentPlan = (paymentPlan) => (
    <PaymentPlan
      key={paymentPlan.id}
      paymentPlan={paymentPlan}
      paymentMethods={paymentMethods}
      paymentMethodOptions={paymentMethodOptions}
      onSelectPlan={onSelectPlan}
      onSelectMethod={onSelectMethod}
      onChangeValue={onChangeValue}
      onDelete={removePaymentPlan}
    />
  )

  return customerName?.length ? (
    <InfoPage
      title="Pagamento"
      subtitle="Formas de pagamento"
      renderMenu={() => <SideMenu step={CHECKOUT_PAYMENT_METHODS} />}
    >
      <Card>
        <Top>
          <strong>
            { `Cliente: ${customerName}` }
          </strong>
        </Top>

        {paymentPlans.map(renderPaymentPlan)}

        <Vouchers
          vouchers={vouchers}
          selectedVouchers={paymentVouchers}
          onSelect={addVoucher}
          onDeselect={removeVoucher}
        />

        <Options>
          <DescItemInfo label="R$ TOTAL">
            {currencyFormat(totalPaid)}
          </DescItemInfo>

          <Button
            onClick={addPaymentPlan}
            disabled={!canAddPaymentPlan()}
            variant="text"
            color="primary"
          >
            Adicionar forma de pagamento
          </Button>
        </Options>

      </Card>

      <Bottom>
        <Button
          onClick={() => history.goBack()}
        >
          <ChevronLeftIcon />
          Voltar
        </Button>

        <Button
          onClick={onClickNext}
          disabled={!canAddPaymentPlan() && !paymentVouchers?.length}
          color="primary"
        >
          Resumo do pagamento
          <ChevronRightIcon />
        </Button>
      </Bottom>

    </InfoPage>
  ) : null
}
